export default __webpack_public_path__ + "static/icon_upload.3c9f2d2e6716aa1610c6a2f461b57bd4.png";